import React from 'react'
import GraphQLErrorList from '../../components/graphql-error-list'
import SEO from '../../components/seo'
import Layout from '../../containers/layout'
import Container from '../../components/container'
import CloudIndexNav from '../../components/cloudIndexNav/cloudIndexNav'
// import CloudIndexResources from '../../components/cloudIndexResources/cloudIndexResources'
import Button from '../../components/button/button'
// import PdfViewer from '../../components/pdfViewer'

import InfraHeader from '../../img/the-infra-red-report.png';
import infraredReport from '../../img/infrared-report.pdf';
import report from '../../img/infrared-report.png'

import * as global from '../../components/globals.module.css'
import * as styles from './infra.module.css'

const CloudReportPage = props => {
    const { data, errors } = props
    if (errors) {
      return (
        <Layout>
          <GraphQLErrorList errors={errors} />
        </Layout>
      )
    }
  
    return (
      <Layout page='cloudReport' hideContactBar={true} version="1">
        <SEO title={`The InfraRed Report`} description={``} keywords={[``]} imageFB={report} />
        
        <CloudIndexNav current='report' />

        <div className={global.offwhite} style={{paddingTop: '60px'}}>
            <Container>
                <h1 className={global.highlight}>
                    <img className={styles.reportHeader} src={InfraHeader} alt="The InfraRed Report" />
                </h1>

                <embed className={styles.pdf} src={infraredReport} type="application/pdf" />

                {/* <PdfViewer file={infraredReport} /> */}

                <div className={styles.mobilePdf}>
                    <Button link={`/infrared-report.pdf`}>Download the report</Button>
                </div>
            </Container>
        </div>

        {/* <CloudIndexResources withWave={true} /> */}
  
      </Layout>
    )
  }
  
  export default CloudReportPage
  